import { render } from "./VikingsStatus.vue?vue&type=template&id=6ad18fa2&scoped=true"
import script from "./VikingsStatus.vue?vue&type=script&lang=js"
export * from "./VikingsStatus.vue?vue&type=script&lang=js"

import "./VikingsStatus.vue?vue&type=style&index=0&id=6ad18fa2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad18fa2"]])

export default __exports__